var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGetHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1,
    fill: "#44837d",
    stroke: "#9CA3AF"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#9CA3AF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 8,
    cy: 8,
    r: 7.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 8,
    cy: 8,
    r: 3.5,
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 10.474,
    y1: 5.526,
    x2: 13.303,
    y2: 2.697,
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 10.474,
    y1: 10.474,
    x2: 13.303,
    y2: 13.303,
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 5.526,
    y1: 10.474,
    x2: 2.697,
    y2: 13.303,
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 5.526,
    y1: 5.526,
    x2: 2.697,
    y2: 2.697,
    "data-color": "color-2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetHelp);
export default __webpack_public_path__ + "static/media/get-help.0448c509.svg";
export { ForwardRef as ReactComponent };